import './index.css';
import React from 'react';
const NoDataSource = _ref => {
  let {
    title
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, title && `Component Name: ${title}`, /*#__PURE__*/React.createElement("h3", {
    className: "m-0"
  }, "No DataSource")))));
};
const commonStyles = "cfp7wo8";
export default NoDataSource;